import React from "react";
import { Link } from "react-router-dom";
import "../css/footer.scss";
import {
  FaInstagram,
  FaFacebookF,
  FaTiktok,
  FaYoutube,
  FaPinterestP,
} from "react-icons/fa";

function Footer() {
  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer className="site-footer" role="contentinfo">
      <div className="footer-top">
        <div className="footer-columns">
          <div className="footer-col">
            <h4 className="footer-heading">Info</h4>
            <ul className="footer-links">
              <li>
                <Link to="/about" onClick={toTop}>
                  About Us
                </Link>
              </li>
            </ul>
            <div className="social-icons">
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaInstagram />
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaFacebookF />
              </a>
              <a
                href="https://tiktok.com"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaTiktok />
              </a>
              <a
                href="https://youtube.com"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaYoutube />
              </a>
              <a
                href="https://pinterest.com"
                target="_blank"
                rel="noreferrer"
                className="social-icon"
              >
                <FaPinterestP />
              </a>
            </div>
          </div>

          <div className="footer-col">
            <h4 className="footer-heading">Support</h4>
            <ul className="footer-links">
              <li>
                <Link to="/returns" onClick={toTop}>
                  Return Policy
                </Link>
              </li>
              <li>
                <Link to="/shipping" onClick={toTop}>
                  Shipping Information
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={toTop}>
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-newsletter">
          <h3 className="newsletter-title">Join Us!</h3>
          <p>
            Daryl Manning
            <br />
            ngdgqixkov174@outlook.com
            <br />
            9750 Royal Lane
            <br />
            Dallas
            <br />
            75231
            <br />
            United States of America
            <br />
            Texas
            <br />
            Call us: +1 4136286170
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-right">
          <p className="copyright">
            Copyright© 2026 Petmorvanto Brands, Inc. All Rights Reserved.
          </p>
          <div className="bottom-links">
            <Link to="/privacy" onClick={toTop}>
              Privacy
            </Link>
            <span className="separator">|</span>
            <Link to="/terms" onClick={toTop}>
              Terms & Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
